// src/components/Management.js
import React, { useState } from "react";
import Logisticsorders from "./Logisticsorders"; // Adjust path if necessary
// import VendorManagement from "../DigitalMenu&Billing/VendorManagement"; // Adjust path if necessary
// import Deliveryorders from "../Grocery/Deliveryorders";
import { Link } from 'react-router-dom';
import "./Logisticresponse.css"
import Logisticsorderdetails from "./Logisticsorderdetails";
function Logisticsandservices() {
    const [activeView, setActiveView] = useState("user");
    const [contentEffectiveStartOffsetString, setContentEffectiveStartOffsetString] = useState("");

    // Style constants
    const activeColor = "#b15cd6";
    const inactiveColor = "#f0f2f5";
    const activeTextColor = "#ffffff";
    const inactiveTextColor = "#333333";
    const activeBorderColor = "#b15cd6";
    const inactiveBorderColor = "#ced4da";

    const commonButtonStyles = {
        padding: "0.5rem 0.5rem",
        borderRadius: "0.375rem",
        fontWeight: 600,
        borderWidth: "1px",
        borderStyle: "solid",
        cursor: "pointer",
        transition:
            "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out",
        outline: "none",
        boxShadow: "none",
    };

    // Original margin for the container-fluid, potentially for a global page header or spacing.
    const pageWrapperMarginTopString = "35px";



    const internalMarginTopValue =
        parseFloat(contentEffectiveStartOffsetString) - parseFloat(pageWrapperMarginTopString);
    const internalMarginTop = `${internalMarginTopValue}px`; // e.g., "45px"

    // The height for the main flex container (which holds the button bar and scrollable content).
    // It should fill the remaining viewport height after accounting for contentEffectiveStartOffset.
    const mainFlexContainerHeight = `calc(100vh - ${contentEffectiveStartOffsetString})`;




    return (
        <div className="container-fluid p-0" style={{ marginTop: '125px' }}>
            <div className="row">
                <div className="col-lg-2"></div> {/* Sidebar or empty space */}
                <div className="col-lg-10 col-md-12 col-sm-12 col-12">
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                      style={{
                            position: "fixed",
                            top: "39px",
                            left: "0vw",

                            width: "auto",          // 👈 full width removed
                            maxWidth: "70%",        // 👈 right side space free
                            display: "inline-block",

                            padding: "30px 20px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "left",
                            margin: 0,
                            height: "70px",

                            zIndex: "9999",
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Orders_Managment
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Logistics & Supply
                        </span>
                    </p>

                    <div
                        style={{

                            marginTop: "20px", // Positions this block correctly within col-lg-10
                            height: mainFlexContainerHeight, // Ensures it fits the desired viewport portion
                        }}
                    >
                        <div style={{ textAlign: "center", marginTop: "-40px" }} className="logistic-res" >
                            <button
                                type="button"
                                className="me-2 btn" // Bootstrap margin utility for spacing between buttons
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "user" ? activeColor : inactiveColor,
                                    color: activeView === "user" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "user" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("user")}
                            >
                                Status
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "vendor" ? activeColor : inactiveColor,
                                    color: activeView === "vendor" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "vendor" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("vendor")}
                            >
                                Reports
                            </button>
                        </div>
                        <div
                            style={{
                                flexGrow: 1, // Allows this div to expand and take up all remaining vertical space
                                // Enables vertical scrolling for this div only when content overflows
                                // Scrollbar hiding (note: Webkit browsers like Chrome/Safari need CSS, e.g., ::-webkit-scrollbar)
                                // IE/Edge
                                // padding: "20px", // Padding for the content inside this scrollable area
                                // Removed marginTop: "-30px" from original, as sticky layout handles spacing.
                            }}
                        >
                            {activeView === "user" && <Logisticsorders />}
                            {activeView === "vendor" && <Logisticsorderdetails />}
                            {/* {activeView === "delivery" && <Deliveryorders />} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Logisticsandservices;